// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "d52ebab49102472f2873f31c080d0669a2255266/static/css/" + chunkId + "." + {"252":"ddced95f","725":"84c1fc5e","854":"36854e5e"}[chunkId] + ".chunk.css";
};